import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactDuplicateConfirmationDialogComponent } from './contact-duplicate-confirmation-dialog.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CtButtonModule, CtFrameworkModule } from '@ctsolution/ct-framework';

@NgModule({
  declarations: [
    ContactDuplicateConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    MatLegacyDialogModule,
    MatIconModule,
    TranslateModule,
    CtFrameworkModule,
    CtButtonModule
  ],
  exports: [
    ContactDuplicateConfirmationDialogComponent
  ]
})
export class ContactDuplicateConfirmationDialogModule { }
